import React from "react";
import "./index.scss";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";

function Bottomfooter() {
  let year = new Date().getFullYear();
  return (
    <Row className="footer">
      <Col md={10} sm={24}>
        <p>{year} Beam.live. All rights reserved.</p>
      </Col>
      <Col md={10} sm={24} className="t-right">
        <Link to={"/privacy-policy"}>Privacy Policy</Link>
        <Link to={"/"}>Terms & Conditions</Link>
      </Col>
    </Row>
  );
}

export default Bottomfooter;
